import React from 'react';
import RangeDatePicker from "../../components/DatePicker/RangeDatePicker";
import moment from "moment";
const DateFilter = ({filter, column, setFilter, withSort}) => {
    const changeFilter = (value) => {
        const from = value.from && moment(value.from).format('YYYY-MM-DDTHH:mm:ss');
        const to = value.to && moment(value.to).format('YYYY-MM-DDTHH:mm:ss');
        let operation;
        if (from && to) operation = 'between'
        else operation = 'equal'

        setFilter({
            fieldName: column.fieldName,
            operation,
            value: (from || to) ? [from, to].toString() : null
        })
    }

    const getDate = (i) => {
        return ((filter || {}).value || '').split(',')[i];
    }

    return (
        <RangeDatePicker
            withSort={withSort}
            placeholder={column.title}
            compact
            dateFromName="from"
            dateFromValue={getDate(0) ? new Date(getDate(0)) : null}
            dateToName="to"
            dateToValue={getDate(1) ? new Date(getDate(1)) : null}
            onChange={(d) => {
                changeFilter(d)
            }}
            pattern='dd.MM.yyyy'
        />
    );
};

export default DateFilter;


// WEBPACK FOOTER //
// ./App/grids/filters/date.jsx